// extracted by mini-css-extract-plugin
module.exports = {"container":"URLSessionExpired_container__uyPj8","description":"URLSessionExpired_description__3Jkgg","text":"URLSessionExpired_text__3Ryij","icon":"URLSessionExpired_icon__3_Qb0"};